import { Box } from "@mui/system"
import { makeStyles } from "tss-react/mui"
import { ApiQueryAutocomplete } from "../../../../../core/api/components/ApiQueryAutocomplete"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { useSupplier } from "../../../supplierHooks"
import {
    fetchMerchantsForSupplier,
    MerchantsResponse,
    SupplierMerchantsQuery,
} from "../../../reporting/merchants/merchantsApi"

const useStyles = makeStyles()((theme) => ({
    input: {
        width: "20rem",
        backgroundColor: theme.palette.common.white,
    },
}))

type SelectMerchantProps = Readonly<{
    setMerchantId: (value: string | undefined) => void
    merchantId?: string
}>

function transformData(data: MerchantsResponse) {
    return data?.merchants
}

export function SelectMerchantAutocomplete({ setMerchantId, merchantId }: SelectMerchantProps) {
    const { classes } = useStyles()
    const { supplierId } = useSupplier()

    const {
        data = [],
        isLoading,
        isError,
    } = useApiQuery(fetchMerchantsForSupplier, {
        queryName: SupplierMerchantsQuery.MERCHANTS_FOR_SUPPLIER,
        dependencies: {
            supplierId,
        },
        select: transformData,
    })

    return (
        <LocalizedStrict id="supplier-acquiring-reports-table-merchant-label" attrs={{ label: true }}>
            <ApiQueryAutocomplete
                label="Merchant"
                isLoading={isLoading}
                isError={isError}
                options={data}
                value={merchantId ? data.find((merchant) => merchant.id === +merchantId) : undefined}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                getOptionLabel={(option) => `${option.name}`}
                renderOption={(props, option) => (
                    <Box component="li" sx={{ ml: "0.5rem" }} {...props}>
                        {option.name}
                    </Box>
                )}
                onChange={(_, value) => {
                    setMerchantId(value ? value.id.toString() : undefined)
                }}
                className={classes.input}
            />
        </LocalizedStrict>
    )
}
